import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Label, Input } from "reactstrap";

const SelectSection = ({ showError, title, value, options, onChange, canEdit, required }) => {
  const [selectValue, setSelectValue] = useState(value);
  const isInvalid = required && (!selectValue || selectValue === -1 || selectValue === "-1");
  const invalidCss = isInvalid && showError ? "is-invalid" : "";
  useEffect(() => setSelectValue(value), [value]);
  return (
    <div className="col-12 mb-3">
      <Label for={title} className={isInvalid && showError && "text-danger"}>
        {title}
        {required && <span className="text-danger"> * </span>}
      </Label>
      <div className="col-12 p-0 input-group">
        <Input
          type="select"
          name={title}
          id={title}
          className={invalidCss}
          onChange={event => {
            const { value: nextValue } = event.target;
            onChange(nextValue);
            setSelectValue(nextValue);
          }}
          disabled={canEdit}
        >
          <option value="-1" className={isInvalid && showError && "text-danger"} selected={value === "-1"}>
            Selecciona una opción
          </option>
          {options}
        </Input>
        {isInvalid && showError && <div className="invalid-feedback">Debe seleccionar una opción.</div>}
      </div>
    </div>
  );
};

SelectSection.propTypes = {
  showError: PropTypes.bool,
  title: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  canEdit: PropTypes.bool,
  required: PropTypes.bool
};

SelectSection.defaultProps = {
  showError: false,
  title: "",
  value: "",
  onChange: () => {},
  options: [],
  canEdit: false,
  required: true
};
export default SelectSection;
